import useModalStore, {
  ModalNames,
} from 'features/multi-porto/stores/modal.store';

import useSubAccounts from './useSubAccounts';

export default function useSwitchAction() {
  const setModal = useModalStore((s) => s.openModal);
  const { getSubAccounts } = useSubAccounts();

  const onOpenTransferCash = () => {
    setModal(ModalNames.TRANSFER_CASH);
  };

  const onOpenTransferStock = () => {
    setModal(ModalNames.TRANSFER_STOCK);
  };

  const onCreatePortfolio = async () => {
    try {
      const data = await getSubAccounts();

      const { can_create_new_sub_account: canCreatePortfolio } = data;

      if (!canCreatePortfolio) {
        setModal(ModalNames.PORTFOLIO_CREATE_BLOCKED);
        return;
      }

      setModal(ModalNames.PORTFOLIO_CREATE);
    } catch (error) {
      console.error(error);
    }
  };

  const onOpenTransferSelect = () => {
    setModal(ModalNames.TRANSFER_SELECT);
  };

  return {
    onOpenTransferCash,
    onOpenTransferStock,
    onCreatePortfolio,
    onOpenTransferSelect,
  };
}
